import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Paginacao } from '../Paginacao';

@Component({
  selector: 'sort-header',
  templateUrl: './sort-header.component.html',
  styleUrls: ['./sort-header.component.scss']
})
export class SortHeaderComponent implements OnInit {

  @Input('objPaginacao')
  objPaginacao: Paginacao<any>

  @Input('columnNameDb')
  columnNameDb: string

  @Output()
  refreshFunction = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  click(){
    this.objPaginacao.alterarOrdenacao(this.columnNameDb);
    this.refreshFunction.emit()
  }

}
